<template>
<div>
  <v-card class="ma-3">
    <g-overlay :is-relay="isOverlay"/>
    <page-progress :is-loading="isLoading"/>
    <page-title icon="mdi-file-replace-outline" title="Live Link Replacement" :show-button="true" btn-link="/invoices"/>
    <v-container class="pt-0" fluid>
      <v-row>
        <v-col cols="12" md="5" sm="12" xl="5" xs="12">
          <v-card>
            <v-card-text>
              <v-row dense no-gutters>
                <v-col cols="12">
                  <v-form ref="detailFormRef" v-model="isReplacementValid" lazy-validation>
                    <v-autocomplete
                        v-model="detail.replacedSite"
                        :rules="requiredFieldRule"
                        :items="details"
                        item-text="site.site_url"
                        item-value="id"
                        outlined
                        dense
                        chips
                        small-chips
                        label="Select a Site"
                        clearable
                        return-object
                        @change="detailHandler"
                    >
                      <template v-slot:item="{ index, item }">
                        <template>
                          <v-list-item-content>
                            <v-list-item-title v-html="item.site.site_url"></v-list-item-title>
                            <v-list-item-subtitle v-html="item.liveLink"></v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-form>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="7" sm="12" xl="7" xs="12">
          <v-card>
            <v-card-text>
              <v-form ref="cartFormRef" v-model="formValid" lazy-validation>
                <v-row dense no-gutters>
                  <v-col cols="12" md="12">
                    <g-p-auto-complete
                        :dense="true"
                        :outlined="true"
                        :search-value="product.site"
                        :status=true
                        :validation="false"
                        apiPath="sites"
                        item-text="siteUrl"
                        search-label="Select a Site"
                        sort-by="site_url"
                        @clearSearchResult="handleClearSearchResult"
                        @selectSearchResult="onSelections"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                        v-model="product.liveLink"
                        label="Replaced Live Link"
                        :rules="requiredFieldRule"
                        outlined
                        dense
                        rows="2"
                        @blur="checkLiveLinks()"
                    />
                  </v-col>
                </v-row>
              </v-form>
              <v-card-actions>
                <v-spacer/>
                <add-button
                    :disabled="!detail.detailId || !product.liveLink"
                    text="Replace Live Link"
                    @onButtonClick="replaceLiveLinkHandler"
                />
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="12" sm="12" xl="12" xs="12">
          <v-card>
            <v-data-table
                :headers="headers"
                :items="carts"
                hide-default-footer
                :disable-pagination="true"
            >
              <template v-slot:footer>
                <v-divider/>
                <v-toolbar flat>
                  <v-spacer/>
                  <cancel-button @onButtonClick="onCancelReplacement"/>
                  <confirm-button
                      text="Confirm"
                      :disabled="!carts.length"
                      @onButtonClick="onConfirmHandler"
                  />
                </v-toolbar>
              </template>
              <template v-slot:top>
                <v-toolbar dense flat>
                  Carts
                </v-toolbar>
              </template>
              <template v-slot:no-data>
                Cart is empty!
              </template>
              <template v-slot:item.actions={item}>
                <v-btn
                    color="error"
                    icon
                    @click="deleteHandler(item)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
  <confirm-popup
      :show="showDeleteConfirm"
      confirm-event="onConfirmDelete"
      @closePopupHandler="showDeleteConfirm = false"
      @onConfirmDelete="deleteHandler(currentItem, true)"
  >
    <div>
      <span>Are you sure to delete this item?</span>
    </div>
  </confirm-popup>
  <confirm-popup
      :show="showReplacementConfirm"
      confirm-event="onConfirmOrder"
      @closePopupHandler="showReplacementConfirm = false"
      @onConfirmOrder="onConfirmHandler(true)"
  >
    <div>
        <span>Are you sure to confirm to submit replacement?
       </span>
    </div>
  </confirm-popup>
</div>
</template>

<script>
import GOverlay from "../components/GOverlay";
import PageProgress from "../components/PageProgress";
import PageTitle from "../components/PageTitle";
import Invoice from "../services/Invoice";
import GPAutoComplete from "../components/GPAutoComplete";
import AddButton from "../components/buttons/AddButton";
import Validation from "../components/mixins/Validation";
import CancelButton from "../components/buttons/CancelButton";
import ConfirmButton from "../components/buttons/ConfirmButton";
import _ from 'lodash';
import ConfirmPopup from "../components/popups/ConfirmPopup";
export default {
  name: "LiveLinkReplacement",
  components: {ConfirmPopup, ConfirmButton, CancelButton, AddButton, GPAutoComplete, PageTitle, PageProgress, GOverlay},
  mixins: [Validation],
  data() {
    return {
      isOverlay: false,
      isLoading: false,
      isReplacementValid: true,
      showDeleteConfirm: false,
      showReplacementConfirm: false,
      formValid: true,
      details: [],
      detail: {
        replacedSite: '',
        detailId: '',
        replaceSiteUrl: '',
        replaceSiteId: '',
        replaceLiveLink: ''
      },
      product: {
        site: '',
        siteUrl: '',
        siteId: '',
        liveLink: ''
      },
      carts: [],
      headers: [
        {
          text: 'Site URL',
          value: 'replaceSiteUrl'
        },
        {
          text: 'Live Link',
          value: 'replaceLiveLink'
        },
        {
          text: 'Replaced Site URL',
          value: 'siteUrl'
        },
        {
          text: 'Replaced Live Link',
          value: 'liveLink'
        },
        {
          text: 'Actions', value: 'actions', sortable: false
        }
      ],
      currentItem: {}
    }
  },
  mounted() {
     this.getSalesCounterDetails();
  },
  methods: {
    getSalesCounterDetails() {
      const id = this.$route.params.id;
      if (!id) return;
      this.isOverlay = true;
      Invoice.invoiceDetails({id})
      .then((response)=> {
        this.details = response.data;

        this.isOverlay = false;
      })
      .catch((errors) => {
        this.isOverlay = false;
        this.$router.push({path: '/invoices'})
      })
    },
    checkLiveLinks() {
      const siteUrl = this.product.siteUrl;
      const linkArr = this.product.liveLink ? this.product.liveLink.split("/") : '';

      if(linkArr.length < 2) {
        this.product.liveLink = '';
        return;
      }

      const linkSite = linkArr[2] ? linkArr[2] : '';

      if(linkSite !== siteUrl) {
        this.product.liveLink = '';
        this.setSnackBar({text: `You are selected this ${siteUrl} and your live link from ${linkSite} does not matched each other. Please check your live link`, type: 'error'})
      }
    },
    handleClearSearchResult() {
      this.product = {
        ...this.product,
        site: '',
        siteUrl: '',
        siteId: '',
      }
    },
    resetProductHandler() {
      this.product = {
        site: '',
        siteUrl: '',
        siteId: '',
        liveLink: ''
      }
    },
    onSelections(selection) {
      const {siteUrl, id: siteId} = selection;

      this.product = {
        siteUrl,
        siteId
      }
      this.checkLiveLinks();
    },
    detailHandler(selection) {
      if(!selection) {
        this.resetDetails();
      } else {
        const {id:detailId, site, siteId: replaceSiteId, liveLink: replaceLiveLink} = selection;

        this.detail = {
          ...this.detail,
          detailId,
          replaceSiteUrl: site.site_url,
          replaceSiteId,
          replaceLiveLink
        }
      }
    },
    replaceLiveLinkHandler() {
      if (!this.$refs.cartFormRef.validate()) return;
     const index = this.carts.findIndex(data => data.detailId === this.detail.detailId);
     if(index > -1) {
       this.carts[index] = {...this.detail, ...this.product};
     } else {
       this.carts.push({...this.detail, id: this.detail.detailId, ...this.product})
     }
     this.$nextTick(()=> {
       this.carts = _.cloneDeep(this.carts);
     })
     this.$refs.cartFormRef.reset();
     this.$refs.detailFormRef.reset();
     this.resetDetails();
     this.resetProductHandler();
    },
    resetDetails() {
      this.detail= {
        replacedSite: '',
        detailId: '',
        replaceSiteUrl: '',
        replaceSiteId: '',
        replaceLiveLink: ''
      }
    },
    deleteHandler(item, confirm=false) {
      if(!confirm) {
        this.currentItem = item;
        this.showDeleteConfirm = true;
        return;
      }

      const id = this.currentItem.id;
      const index = this.carts.findIndex((item) => item.id === id);

      if (index > -1) {
        this.carts.splice(index, 1);
      }

      this.showDeleteConfirm = false;
      this.currentItem = null;
    },
    onCancelReplacement() {
      this.$refs.cartFormRef.reset();
      this.$refs.detailFormRef.reset();
      this.carts = [];
      this.resetDetails();
      this.resetProductHandler();
    },
    onConfirmHandler(confirm = false) {
      if(!confirm) {
        this.showReplacementConfirm = true;
        return;
      }
      this.showReplacementConfirm = false;

      Invoice.replacement({carts: this.carts})
      .then((response)=> {
        this.setSnackBar({text: response.data.message, type: 'info'});
        this.$router.push({path: '/invoices'})
      })
      .catch((errors)=> {
        this.setSnackBar({text: 'Something wrong, please check', type: 'error'})
      })

    },
    setSnackBar({text, type}) {
      this.$store.commit('SET_SNACKBAR', {text, type});
    },
  }
}
</script>

<style scoped>

</style>